import React, { Component } from "react";
import classes from "./AssignUser.module.css";
import axios from "../../../../axios-order";
import Button from "@material-ui/core/Button";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { ValidatorForm } from "react-material-ui-form-validator";
import { toast } from "react-toastify";

import Appbar from "../../../../components/appBar/appBar";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import InputField from "../../../../components/ui/inputField";
import Footer from "../../../../components/footer/footer";
import CheckIcon from "@material-ui/icons/Check";
// import "../../../../HOC/layout/layout.css";
import BoxWrapper from "../../../../components/ui/boxWrapper";


const hierarchyOrder = ["CHAMP", "LEADERSHIP", "SUPERADMIN", "ADMIN", "USER"];

const canManageUser = (targetRole) => {
  const myRole = localStorage.getItem("role")?.toUpperCase();
  if (!myRole || !targetRole) return false;
  const target = targetRole.toUpperCase();
  if (myRole === target) return false;
  switch (myRole) {
    case "CHAMP":
      return true;

    case "LEADERSHIP":
      return ["SUPERADMIN", "ADMIN", "USER"].includes(target);

    case "SUPERADMIN":
      return ["ADMIN", "USER"].includes(target);

    case "ADMIN":
      return target === "USER";

    default:
      return false;
  }
};

const useStyles = makeStyles({
  list: {
    width: 1050,
    height: 1000,
  },
  fullList: {
    width: "auto",
  },
});

class AssignUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      entityUsers: [],
      original_new_user_data: null,
      newEntityUsers: [],
      checkboxStates: {},
      actionCheckboxStates: {},
      assigned_user_loading: false,
      new_user_loading: false,
      business_entity_id: localStorage.getItem("business_mgmt_entity_id"),
      entity_name_for_assign_user_page: localStorage.getItem(
        "entity_name_for_assign_user_page",
      ),
      business_entity_notification_flag: false,
    };
  }

  // ---Add user table search---
  handleSearchInputChange = (event) => {
    this.setState({ searchInput: event.target.value }, () => {
      this.addUserTableSearch(event);
     
    });
  };

  addUserTableSearch = () => {
    let { searchInput, original_new_user_data } = this.state;
    let searchData = original_new_user_data.filter((value) => {
      const query = searchInput.toLowerCase();
      return (
        value.user_name.toLowerCase().indexOf(query) >= 0 ||
        value.user_role.toLowerCase().indexOf(query) >= 0 ||
        value.status.toLowerCase().indexOf(query) >= 0 ||
        value.user_email_id.toLowerCase().indexOf(query) >= 0
      );
    });
    this.setState({ newEntityUsers: searchData });
  };
  

  // --End--

  componentDidMount = () => {
    this.getEntityUser();
    this.getAddUserData();
  };

  getEntityUser = () => {
    let business_entity_id = this.state.business_entity_id;
    this.setState({ assigned_user_loading: true });
    axios
      .get(`/get_entity_users/${business_entity_id}`)
      .then((res) => {
        if (res.data.records) {
          this.setState({
            entityUsers: res.data.records,
            assigned_user_loading: false,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ entityUsers: "", assigned_user_loading: false });
      });
  };

getAddUserData = () => {
  this.setState({ new_user_loading: true });
  const user_id = localStorage.getItem("user_id");
  axios
    .get(`/get_new_entity_users/${this.state.business_entity_id}/${user_id}`)
    .then((res) => {
      const users =
        // (res.data.List_of_active_users?.length && res.data.List_of_active_users) ||
        (res.data.records?.length && res.data.records) ||
        [];

      this.setState(
        {
          newEntityUsers: users,
          original_new_user_data: users,
          new_user_loading: false,
        },
        () => {
          if (this.state.searchInput) {
            this.addUserTableSearch();
          }
        },
      );
    })
    .catch((error) => {
      console.log(error);
      this.setState({ new_user_loading: false });
    });
};

  handleDeleteAssignedUser = (user_id) => {
    axios
      .delete(
        `/post_delete_entity_user/${this.state.business_entity_id}/${user_id}`,
      )
      .then((res) => {
        this.getEntityUser();
        this.getAddUserData();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // ---Entity user table---
  entityTableHeader() {
    const tableHeader = [
      "user name",
      "user email id",
      "user contact number",
      "user role",
      "status",
      "business notification",
      "Action",
      "Edit",
    ];
    return tableHeader.map((key, index) => {
      return <th key={index}>{key.toUpperCase()}</th>;
    });
  }
  entityTableData() {
    if (this.state.assigned_user_loading) {
      return (
        <tr>
          <td colSpan={8}>Loading.Please wait...</td>
        </tr>
      );
    }
    if (this.state.entityUsers.length) {
      return this.state.entityUsers.map((tableData, index) => {
        const {
          user_name,
          user_email_id,
          user_contact_number,
          user_id,
          user_role,
          business_entity_notification_flag,
          status,
        } = tableData;
        const canManage = canManageUser(user_role);
        return (
          <tr key={index}>
            <td style={{ textTransform: "capitalize" }}>{user_name}</td>
            <td>{user_email_id}</td>
            <td>{user_contact_number}</td>
            <td>{user_role}</td>
            <td style={{ textTransform: "capitalize" }}>{status}</td>
            {business_entity_notification_flag === "True" ? (
              <td>
                <CheckIcon style={{ color: "green" }} />
              </td>
            ) : (
              <td></td>
            )}

            <td>
              <Button
                style={{
                  fontFamily: "Dosis",
                  fontWeight: "650",
                  color: canManage ? "var(--app-bar-bg)" : "#999",
                }}
                size="small"
                disabled={!canManage}
                onClick={() => this.handleDeleteAssignedUser(user_id)}
              >
                Delete
              </Button>
            </td>
            <td>
              <Button
                style={{
                  fontFamily: "Dosis",
                  fontWeight: "650",
                  color: canManage ? "var(--app-bar-bg)" : "#999",
                }}
                size="small"
                disabled={!canManage}
                onClick={() => this.handleEditUser(user_id)}
              >
                Edit
              </Button>
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td style={{ color: "red" }} colSpan={8}>
            No Assigned User!
          </td>
        </tr>
      );
    }
  }

  // ---add new  user table---
  addNewUserTableHeader() {
    const tableHeader = [
      "user name",
      "user email id",
      "user contact number",
      "user role",
      "status",
      "business notification",
      "Select",
    ];
    return tableHeader.map((key, index) => {
      return <th key={index}>{key.toUpperCase()}</th>;
    });
  }
  addNewUserTableData() {
    if (this.state.new_user_loading) {
      return (
        <tr>
          <td colSpan={8}>Loading.Please wait...</td>
        </tr>
      );
    }
    if (this.state.newEntityUsers.length) {
      return this.state.newEntityUsers.map((tableData, index) => {
        const {
          user_name,
          user_email_id,
          user_contact_number,
          user_id,
          user_role,
          status,
        } = tableData;
        return (
          <tr key={index}>
            <td style={{ textTransform: "capitalize" }}>{user_name}</td>
            <td>{user_email_id}</td>
            <td>{user_contact_number}</td>
            <td>{user_role}</td>
            <td style={{ textTransform: "capitalize" }}>{status}</td>
            <td>
              <Checkbox
                color="primary"
                name="business_entity_notification_flag"
                checked={this.state.checkboxStates[user_id] || false}
                onChange={this.handleCheckBoxChange(user_id)}
                inputProps={{ "aria-label": "uncontrolled-checkbox" }}
                size="small"
              />
            </td>
            <td>
              <Checkbox
                color="primary"
                size="small"
                checked={this.state.actionCheckboxStates[user_id] || false}
                onChange={this.handleActionCheckboxChange(user_id)}
              />
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td style={{ color: "red" }} colSpan={8}>
            No data found!
          </td>
        </tr>
      );
    }
  }

  handleCheckBoxChange = (user_id) => (event) => {
    const checked = event.target.checked;
  
    this.setState((prevState) => ({
      checkboxStates: {
        ...prevState.checkboxStates,
        [user_id]: checked,
      },
    }));
  };

  handleActionCheckboxChange = (user_id) => (event) => {
    const checked = event.target.checked;

    this.setState((prevState) => ({
      actionCheckboxStates: {
        ...prevState.actionCheckboxStates,
        [user_id]: checked,
      },
    }));
  };

  handleEditUser = (user_id) => {
    axios
      .post("/get_user_services", {
        user_id: user_id,
        business_entity_id: parseInt(this.state.business_entity_id),
      })
      .then((res) => {
        if (res.data.status) {
          this.props.history.push(`/businessEntityManagement/addNewUser`, {
            users: [user_id],
            business_entity_id: this.state.business_entity_id,
            existing_services: res.data.data.services_data,
            is_edit: true,
          });
        } else {
          toast.error("No services found for this user");
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error("Couldn't fetch user services. Please try again");
      });
  };

  createGroup = () => {
    this.props.history.push(`/businessEntityManagement/addNewUser`, {
      users: Object.keys(this.state.actionCheckboxStates).filter(
        (k) => this.state.actionCheckboxStates[k],
      ),
      business_entity_id: this.state.business_entity_id,
      is_create_group: true,
    });
  };

  adduserSubmitHandler = (user_id, status) => {
    const { checkboxStates } = this.state;
    let add_entity_data = {
      status: status,
      business_entity_notification_flag: checkboxStates[user_id] || false,
      user_id: user_id,
      business_entity_id: parseInt(this.state.business_entity_id),
    };
  

    axios
      .post("/post_entity_user", add_entity_data)
      .then((res) => {
        this.getAddUserData();
        this.getEntityUser();
        this.setState((prevState) => ({
          checkboxStates: {
            ...prevState.checkboxStates,
            [user_id]: false,
          },
        }));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //   ---Add new User---
  addNewUser = () => {
    if (!Object.values(this.state.actionCheckboxStates || {}).some(Boolean)) {
      toast.error("Please Select a user");
      return;
    }
    this.props.history.push(`/businessEntityManagement/addNewUser`, {
      users: Object.keys(this.state.actionCheckboxStates).filter(
        (k) => this.state.actionCheckboxStates[k],
      ),
      business_entity_id: this.state.business_entity_id,
    });
  };

  backHandler = () => {
    localStorage.removeItem("entity_name_for_assign_user_page");
    this.props.history.goBack();
  };

  render() {
    return (
      <>
        <Appbar />
        <div className={classes.AssignUserSection}>
          <button
            className="button-outlined-primary"
            onClick={this.backHandler}
          >
            back
          </button>

          <BoxWrapper
            boxTitle={`Assigned Users for ${localStorage.getItem(
              "entity_name_for_assign_user_page",
            )}`}
          >
            <div className="responsive-table">
              <table className="custome-table">
                <tbody>
                  <tr>{this.entityTableHeader()}</tr>
                  {this.entityTableData()}
                </tbody>
              </table>
            </div>
          </BoxWrapper>

          <BoxWrapper
            boxTitle="Add New User"
            enableSecondButton={false}
            secondButtonLabel="Create Group"
            secondButtonHandlerFn={this.createGroup}
            enableAddButton={true}
            addButtonHandlerFn={this.addNewUser}
            addButtonLabel="Add"
            isAddButtonActive={!this.state.new_user_loading}
            enableSearchInput={true}
            searchInputPlaceholder="Search..."
            searchInputOnchange={this.handleSearchInputChange}
          >
            <div className="responsive-table">
              <table className="custome-table">
                <tbody>
                  <tr>{this.addNewUserTableHeader()}</tr>
                  {this.addNewUserTableData()}
                </tbody>
              </table>
            </div>
          </BoxWrapper>
        </div>
        {/* ---Footer--- */}
        <div>
          <Footer />
        </div>
        {/* ---Footer End--- */}
      </>
    );
  }
}

export default withStyles(useStyles, { withTheme: true })(AssignUser);
